/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getCurrentPage__anchor
 */
export default () => window.documentViewer.getCurrentPage();